import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { reviewSettingAdditionalCommentData } from "../../sample-data";

const initialState = {
  data: {},
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchReviewSettingAdditionalCommentOne = createAsyncThunk(
  "ReviewSettingAdditionalCommentOne/fetchReviewSettingAdditionalCommentOne",
  async ({ rascId }, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    return (
      reviewSettingAdditionalCommentData.find((x) => x.rascId == rascId) || {}
    );
    try {
      const response = await axios.get(url, {
        validateStatus: (status) => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceReviewSettingAdditionalCommentOne = createSlice({
  name: "ReviewSettingAdditionalCommentOne",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewSettingAdditionalCommentOne.pending, (state) => {
        state.data = {};
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(
        fetchReviewSettingAdditionalCommentOne.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = ""; // Reset error on successful fetch
        }
      )
      .addCase(
        fetchReviewSettingAdditionalCommentOne.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
          console.log(state.error);
        }
      );
  },
});

export const selectReviewSettingAdditionalCommentOneData = (state) =>
  state.ReviewSettingAdditionalCommentOne.data;
export const selectIsLoading = (state) =>
  state.ReviewSettingAdditionalCommentOne.isLoading;
export const selectError = (state) =>
  state.ReviewSettingAdditionalCommentOne.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.ReviewSettingAdditionalCommentOne.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.ReviewSettingAdditionalCommentOne.data,
  isLoading: state.ReviewSettingAdditionalCommentOne.isLoading,
  error: state.ReviewSettingAdditionalCommentOne.error,
}));
*/
export default sliceReviewSettingAdditionalCommentOne.reducer; // Export the reducer
